import {Component, OnInit, HostListener, Optional , Inject, OnDestroy, Output, EventEmitter} from '@angular/core';
import {MatDialogRef, MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { AnonymousSignService } from 'src/app/core/services/anonymous-sign.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CommonService } from 'src/app/core/services/common.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { LoginBase } from '../../../login-base';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-anonymous-cloud-ca',
  templateUrl: './anonymous-cloud-ca.component.html',
  styleUrls: ['./anonymous-cloud-ca.component.scss']
})
export class AnonymousCloudCaComponent extends LoginBase implements OnInit, OnDestroy {
  public cancelFlow = false;
  providerName: string = '';
  lstCloudCaProvider: any[];
  cloudCaUsername: string;
  cloudCaDataSource: any[] = [];
  selectedCert: any = null;
  isDialog: boolean = false;
  isFormChanging: boolean = false;
  @BlockUI() blockUI: NgBlockUI;
  
  @Output() actionBack = new EventEmitter<string>();
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private authenSer: AuthenticationService,
    private anonymousSignService: AnonymousSignService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<AnonymousCloudCaComponent>, 
  ) {
    super();
    if (data) {
      this.isDialog = data;
    }
  }
  ngOnDestroy(): void {
  }


  ngOnInit() {
    this.initData();
  }

  initData() {
    this.commonService.getAllCloudCaProvider().subscribe(rs => {
      if (rs && rs.data) {
        this.lstCloudCaProvider = rs.data;
        this.providerName = this.lstCloudCaProvider[0].name;
      }
    });
  }
  backToPrePage() {
    if (this.isDialog) {
      if (this.isFormChanging) {
        const dialogRe = this.dialog.open(WarningComponent, {
          width: '350px',
          data: this.message.getMessage('messages.confirm_change_data'),
          panelClass: 'scontract-overlay-dialog',
          disableClose: true
        });
        dialogRe.afterClosed().subscribe(res => {
          if (res) {
            this.dialogRef.close();
          }
        })
      } else {
        this.dialogRef.close();
      }
    } else {
      this.actionBack.emit('LOGIN');
    }
  }
  getCertificateCloudCa() {
    this.isFormChanging = true;
    this.blockUI.start('');
    this.authenSer.getCertsCloudCa(this.cloudCaUsername, this.providerName).subscribe(rs => {
      if (rs && rs.data && rs.data.length > 0) {
        this.cloudCaDataSource = rs.data.map((item, index) => {
          return {
            ...item,
            STT: index + 1,
            cloudCaProviderName: this.providerName
          };
        });
      } else {
        if (rs.code === ErrorCode.CLOUD_CA_EXPIRED) {
          this.actionBack.emit('LOGIN');
        } 
        this.toastr.error(rs.message);
      }
    }, error => {
    },
    () => {
      this.blockUI.stop();
    });
  }
  onSelectedCloudCaCert(event: any, cert) {
    this.isFormChanging = true;
    if (event === true) {
      this.selectedCert = cert;
      this.cloudCaDataSource = this.cloudCaDataSource.map(item => {
        return {...item, checked: cert.STT === item.STT};
      });
    } else {
      this.selectedCert = null;
      this.cloudCaDataSource = this.cloudCaDataSource.map(item => {
        return {...item, checked: false};
      });
    }
  }
  onConfirmData() {
    if (this.selectedCert) {
      this.anonymousSignService.selectedCert.next(this.selectedCert);
      if (this.isDialog) {
        this.dialogRef.close();
      } else {
        this.actionBack.emit('SIGN');
      }
    } else {
      this.dialogRef.close();
    }
  }
}
